import axios from 'axios'

import { CalculationServiceVehicleFleetApi } from '../../../publish/calculation/apis/calculation-service-vehicle-fleet-api'
import { Configuration } from '../../../publish/calculation/configuration'
import { setupAxiosInterceptors } from '../../axios-interceptor-utils'

export class CalculationServiceVehicleFleet extends CalculationServiceVehicleFleetApi {
  constructor(
    protected basePath: string,
    private getTokenFn?: () => Promise<string>,
  ) {
    super(new Configuration({ basePath: basePath }), basePath, axios.create())
    setupAxiosInterceptors(this.axios, this.getTokenFn)
  }
}
